import React, { Suspense, lazy } from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import SiteAnalytics from './components/SiteAnalytics'
import { captureInstallPrompt } from './utils/installPrompt'

const path = typeof window !== 'undefined' ? window.location.pathname : '/'
const isManage = path === '/manage' || path.startsWith('/manage/')
const isReports = path === '/reports' || path.startsWith('/reports/')
const RouteApp = path === '/practice-lab'
  ? lazy(() => import('./components/BeginnerPractice'))
  : path === '/peer-feedback'
    ? lazy(() => import('./components/PeerFeedbackPage'))
    : path.startsWith('/feedback/')
      ? lazy(() => import('./components/FeedbackRespondent'))
      : isManage
        ? lazy(() => import('./manage/ManageApp'))
        : isReports
          ? lazy(() => import('./account/ReportsApp'))
          : path === '/access' || path === '/'
            ? lazy(() => import('./account/CustomerEntry'))
            : lazy(() => import('./App'))

captureInstallPrompt()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Suspense fallback={<main className="route-loading" role="status">Loading…</main>}>
      <RouteApp />
    </Suspense>
    <SiteAnalytics />
  </React.StrictMode>,
)
